import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Input, Form } from "antd";
import { setInputMode } from "../../services/input";

export const PostalCodeFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <Form.Item label="郵便番号">
      <Input
        ref={setInputMode("tel")}
        value={store.postalCode}
        onChange={e => {
          store.postalCode = e.target.value;
        }}
      />
    </Form.Item>
  );
});
